<template>
  <sc-render :fields="fields" :empty-message="$t('NO_DATA_SOURCE_EXIST')">
    <sc-clickable :href="linkHref" class="tile-wrapper">
      <div :class="tileClasses">
        <div class="text-tile__content">
          <sc-text class="title" tag="p" :field="title || {}" />
          <sc-text class="tag" tag="p" :field="tag || {}" />
        </div>
      </div>
    </sc-clickable>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text } from '@sitecore-jss/sitecore-jss-vue'
import ScRender from '~/components/sitecore/sc-render'
import ScClickable from '~/components/sitecore/sc-clickable'
import mapFields from '~/helpers/map-fields'
import TILE_RATIO from '~/constants/aspect-ratios'
import ThemeMixin from '~/mixins/theme'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'CarouselTextTile',

  components: {
    ScText: Text,
    ScRender,
    ScClickable
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  mixins: [ThemeMixin],

  computed: {
    ...mapJssGetters(['isEditMode']),

    ...mapFields({
      title: 'title',
      tag: 'tag',
      link: 'link',
      linkHref: 'link.value.href',
      aspectRatio: 'aspectRatio.fields.ratio.value'
    }),

    tileClasses () {
      return [
        'text-tile',
        `text-tile--${TILE_RATIO[this.aspectRatio] || TILE_RATIO['3:4']}`,
        {
          'text-tile--edit': this.isEditMode,
          'text-tile--dark': this.isDarkTheme
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
$text-tile-min-width: 300px;
$text-tile-max-width: 600px;

.text-tile {
  position: relative;
  min-width: 80vw;

  @include tablet {
    min-width: $text-tile-min-width;
    max-width: $text-tile-max-width;
    width: 25vw;
  }

  &--1x1 {
    @include ratio(1, 1);
  }

  &--3x4 {
    @include ratio(3, 4);
  }

  &__content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid $color-black;

    .title {
      @include font('060');
      text-align: center;
      text-transform: uppercase;
      padding: 0 $space-060;

      @include tablet {
        @include font('100');
      }
    }

    .tag {
      @include font('040');
      color: $color-slate-gray;
      text-align: center;
      position: absolute;
      bottom: $space-050;
      width: 100%;

      @include tablet {
        @include font('050');
      }
    }
  }

  &--dark &__content {
    border-color: $color-white;

    .tag {
      color: $color-cream;
    }
  }

  &--edit {
    margin-right: $space-050;
  }
}
</style>
